import * as React from 'react';
import { Section, Breadcrumbs } from '../modules/modules';
import CountryService from '../services/CountryService';
import PriceListForm from '../components/PriceList';

class PriceListPage extends React.Component<{}> {

  public render() {
    const { countryCode } = CountryService.GetInstance();

    return (
      <main>
        <Section type="pricelist">
          <div className="container">

            <div className="row">
              <div className="col-12">
                <Breadcrumbs
                  links={[{
                    value: '',
                    link: `/${countryCode}`
                  }, {
                    value: 'Price list',
                    link: `/${countryCode}/pricelist`
                  }]}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <PriceListForm />
              </div>
            </div>
          </div>
        </Section>
      </main>
    );
  }
}

export default PriceListPage;


// WEBPACK FOOTER //
// ./src/pages/PriceList.tsx